import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { StorySection } from "./components/sections/StorySection";
import { PathwaySection } from "./components/sections/PathwaySection";
import { PainSection } from "./components/sections/PainSection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { ToolsSection } from "./components/sections/ToolsSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { PriceReasonSection, GuaranteeSection } from "./components/sections/PriceGuaranteeSection";
import { TransformationSection } from "./components/sections/TransformationSection";
import { DoctorMessageSection } from "./components/sections/DoctorMessageSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { AboutSection } from "./components/sections/AboutSection";
import { FaqSection } from "./components/sections/FaqSection";
import { FinalCtaSection, Footer } from "./components/sections/FinalCtaSection";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink" data-id="element-0" data-mp="6hovayao7c0">
      <MetaPixel data-id="element-1" data-mp="2zld2jatxbhc2" />
      <Hero data-id="element-2" data-mp="2zlv7qwykd5w4" />
      <main data-id="element-3" data-mp="2zmepodo7rua5">
        <StorySection data-id="element-4" data-mp="2zmo6pbra6r3p" />
        <PathwaySection data-id="element-5" data-mp="2zng1ikd20ksx" />
        <PainSection data-id="element-6" data-mp="33mf0zpg0npcz" />
        <VolumesSection data-id="element-7" data-mp="33nq5xsl7735o" />
        <ToolsSection data-id="element-8" data-mp="33n6wl09m5n39" />
        <BonusesSection data-id="element-9" data-mp="33oi2p6qj76xj" />
        <OfferSection data-id="element-10" data-mp="38l8hzruihyhw" />
        <PriceReasonSection data-id="element-11" data-mp="38kqbm2e4y3w9" />
        <GuaranteeSection data-id="element-12" data-mp="38kgm0fx05yr3" />
        <TransformationSection data-id="element-13" data-mp="3dkuwe4m2tksa" />
        <DoctorMessageSection data-id="element-14" data-mp="3dl4k1ljnffut" />
        <TestimonialsSection data-id="element-15" data-mp="3dm5xtxs1ugg8" />
        <AboutSection data-id="element-16" data-mp="nvj2rdpwcaoo" />
        <FaqSection data-id="element-17" data-mp="nw2egcoye2u9" />
        <FinalCtaSection data-id="element-18" data-mp="nur6s1se0axv" />
      </main>
      <Footer data-id="element-19" data-mp="nxwwnj8ubgun" />
      <FloatingCta data-id="element-20" data-mp="sunf2d84aoj8" />
      <PurchasePopup data-id="element-21" data-mp="stuejtzr4v9j" />
    </div>;
}